import React, { useState } from "react";

const advantagesData = [
  { title: "Fast Transactions", content: "TRON blockchain processes transactions at high speeds, reducing wait times significantly compared to traditional systems." },
  { title: "Low Fees", content: "Transactions on TRON have significantly lower fees compared to traditional payment methods, maximizing your margins." },
  { title: "Global Reach", content: "Businesses can access a worldwide audience without geographical restrictions — 150+ countries supported." },
  { title: "Security", content: "Blockchain technology ensures secure and transparent transactions, with no intermediaries or smart contract risk." },
  { title: "Increased Customer Base", content: "Cryptocurrency payments attract tech-savvy customers from around the world, expanding your total addressable market." },
];

const Advantages = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="section px-6 py-24 max-w-7xl mx-auto">
      <div
        className="rounded-3xl overflow-hidden"
        style={{
          background: "linear-gradient(135deg, #0d1120, #06080f)",
          border: "1px solid rgba(255,255,255,0.06)",
        }}
      >
        <div className="p-12 lg:p-16">
          <div className="grid lg:grid-cols-2 gap-16 items-start">
            {/* Left */}
            <div>
              <div className="badge mb-6">
                <span className="badge-dot" />
                Benefits
              </div>
              <h2
                className="font-syne font-bold mb-5"
                style={{ fontSize: "clamp(30px, 3.5vw, 48px)", color: "#e8eaf0" }}
              >
                Advantages of Using the <span className="grad-text">CAHEX Network</span> for Payments
              </h2>
              <p
                className="text-base leading-relaxed"
                style={{ color: "var(--c-muted)", fontFamily: "'DM Sans', sans-serif" }}
              >
                Per the TRON project, businesses that accept payments leveraging the TRON blockchain can enjoy numerous benefits — rapid transaction processing speed, minimal fees, and access to a global customer base.
              </p>

              {/* Visual metric boxes */}
              <div className="grid grid-cols-2 gap-4 mt-10">
                {[["99.9%", "Uptime SLA"], ["2s", "Avg Settlement"], ["0.1%", "Network Fee"], ["150+", "Countries"]].map(([v, l]) => (
                  <div
                    key={l}
                    className="rounded-xl p-4"
                    style={{ background: "rgba(82,198,168,0.04)", border: "1px solid rgba(82,198,168,0.1)" }}
                  >
                    <div className="font-syne font-bold text-2xl grad-text">{v}</div>
                    <div className="text-xs mt-1" style={{ color: "var(--c-muted)", fontFamily: "'DM Sans', sans-serif" }}>{l}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Right — accordion */}
            <div className="space-y-2">
              {advantagesData.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <div
                    key={index}
                    className="rounded-xl overflow-hidden transition-all duration-200"
                    style={{
                      border: isOpen ? "1px solid rgba(82,198,168,0.3)" : "1px solid rgba(255,255,255,0.06)",
                      background: isOpen ? "rgba(82,198,168,0.05)" : "rgba(255,255,255,0.02)",
                    }}
                  >
                    <button
                      className="w-full flex items-center justify-between px-5 py-4 cursor-pointer text-left"
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                    >
                      <span
                        className="font-syne font-semibold text-sm"
                        style={{ color: isOpen ? "#52c6a8" : "#e8eaf0" }}
                      >
                        {item.title}
                      </span>
                      <span
                        className="text-lg transition-transform duration-300 ml-4 flex-shrink-0"
                        style={{
                          color: isOpen ? "#52c6a8" : "var(--c-muted)",
                          transform: isOpen ? "rotate(45deg)" : "rotate(0deg)",
                        }}
                      >
                        +
                      </span>
                    </button>
                    {isOpen && (
                      <div
                        className="px-5 pb-4 text-sm leading-relaxed"
                        style={{ color: "var(--c-muted)", fontFamily: "'DM Sans', sans-serif" }}
                      >
                        {item.content}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Advantages;
